export default __webpack_public_path__ + "static/media/2.5f4da008.jpeg";